import {Header} from '@/components/organisms'
import {AuthContext} from '@/context/Auth/AuthContext'
import {isFeatureEnabled} from '@/helpers/featureToggle'
import {useAppDispatch, useAppSelector} from '@/store'
import {resetToastNotifications, selectShellActive, selectShellPath, setShellPath} from '@/store/slices/commonSlice'
import {selectIsNorthAmerica} from '@/store/slices/countryCodeSlice'
import {FeatureToggle} from '@/utils/constants/featuresFlag'
import {useTheme} from '@pepsico-ds/ui'
import {useContext, useEffect} from 'react'
import {useSelector} from 'react-redux'
import {useLocation, useNavigate} from 'react-router-dom'
import logo from '../../assets/img/logo-pepsico-h.svg'
import {SidebarMenu} from '../../components/molecules'
import {Alert} from '../../components-v2/molecules'
import {HeaderExtraItems} from './components/HeaderExtraItems'
export const Template = ({children}) => {
  const {isAuthenticated} = useContext(AuthContext)
  return isAuthenticated ? <Logged>{children}</Logged> : <Logged>{children}</Logged>
}

const Logged = props => {
  const navigate = useNavigate()
  const location = useLocation()
  const shellActive = useAppSelector(selectShellActive)
  const shellPath = useAppSelector(selectShellPath)
  const dispatch = useAppDispatch()
  const {toastNotifications} = useAppSelector(state => state.common)
  const isB2BAdmin = location.pathname.includes('b2b-admin')
  const isNorthAmerica = useSelector(selectIsNorthAmerica)

  const {currentTheme} = useTheme()

  const shouldUseDarkPepsiConnectClass = isNorthAmerica || currentTheme === 'Dark PepsiConnect'

  useEffect(() => {
    // important: immediately navigate to shellPath received from the top shell & reset it
    if (shellPath) {
      navigate(shellPath)
      setTimeout(() => {
        dispatch(setShellPath(''))
      }, 10)
    }
  }, [shellPath, navigate, dispatch])

  const onToastClose = () => {
    dispatch(resetToastNotifications())
  }

  return (
    <>
      {!shellActive && (
        <Header logo={logo} title="B2B Admin Tool">
          {isFeatureEnabled(FeatureToggle.userGuide) && <HeaderExtraItems />}
        </Header>
      )}
      <div
        data-testid="content"
        className={`relative flex h-full ${isB2BAdmin ? 'max-h-[calc(100vh-4rem)]' : 'h-full'}`}
      >
        {!shellActive && <SidebarMenu />}
        <main
          data-testid="content-main"
          data-cy="content-main"
          className={`${shouldUseDarkPepsiConnectClass ? 'dark-pepsiconnect' : 'dark-mode bg-background'} ${shellActive ? 'm-0' : 'ml-20 pl-8'} w-full overflow-auto pr-6 pt-7 text-zinc-800`}
          {...props}
        />

        {toastNotifications.show && (
          <Alert
            data-cy="feedback-alert"
            type={toastNotifications.type}
            message={toastNotifications.message}
            details={toastNotifications.details}
            show={toastNotifications.show}
            onCloseClick={onToastClose}
          />
        )}
      </div>
    </>
  )
}
